export { analyticsTracker } from './analytics-tracker.esm.js';
export { classNames } from './classnames.esm.js';
export { MakeEgdsSizingLength } from './egds-sizing-length.esm.js';
export { Level, liveAnnounce } from './live-announce.esm.js';
export { ResolutionStrategy, ScriptLoader, checkScriptIsLoaded, documentHead, loadScript } from './script-loader.esm.js';
export { UitkContextProvider, UitkContextWrapper, useUitkContext } from './uitk-context-provider.esm.js';
export { UitkThemeProvider } from './uitk-theme-provider.esm.js';
export { validateChildTypeNames, validateChildTypes } from './validate-child-types.esm.js';
export { validatePropType } from './validate-prop-types.esm.js';
export { isElementVisible } from './is-element-visible.esm.js';
export { initGoogleMapsApi } from './map-provider/google-api.esm.js';
export { initMapBoxApi } from './map-provider/mapbox-api.esm.js';
export { getErrorMessage, isErrorWithMessage, toErrorWithMessage } from './get-error-message.esm.js';

if (typeof document !== 'undefined') {
    var addBodyClass_1 = function () {
        if (!document.body.classList.contains('uitk-no-outline')) {
            document.body.classList.add('uitk-no-outline');
            // Manage event listeners
            document.body.removeEventListener('mousedown', addBodyClass_1);
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            document.body.addEventListener('keydown', removeBodyClass_1);
        }
    };
    var removeBodyClass_1 = function () {
        if (document.body.classList.contains('uitk-no-outline')) {
            document.body.classList.remove('uitk-no-outline');
            // Manage event listeners
            document.body.removeEventListener('keydown', removeBodyClass_1);
            document.body.addEventListener('mousedown', addBodyClass_1);
        }
    };
    // Auto-initialize
    addBodyClass_1();
}
